import React from "react";
import PropTypes from "prop-types";
import { ReactTyped } from "react-typed";
import { Toolbar, Container, IconButton, Grid, Link, Stack } from "@mui/material";
import { Facebook, Twitter, Instagram, Menu as MenuIcon } from "@mui/icons-material";
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";
import { useLanguage } from "context/LanguageContext";
import bgImage from "assets/images/bg-coworking.jpeg";
import { ReactComponent as Logo } from "assets/images/macoce-logo.svg";

function HeaderContent({ centered }) {
  const { messages } = useLanguage();

  return (
    <>
      <MKTypography variant={centered ? "h3" : "h1"} color="white">
        {messages.hero.titlePrefix}
      </MKTypography>
      <MKTypography variant={centered ? "h3" : "h1"} color="white">
        <ReactTyped
          strings={messages.hero.typedWords}
          typeSpeed={50}
          backSpeed={20}
          backDelay={1000}
          startDelay={500}
          loop
        />
      </MKTypography>
      <MKTypography
        variant={centered ? "h6" : "body1"}
        color="white"
        mt={4}
        opacity={0.8}
        pr={centered ? 0 : 6}
        mr={centered ? 0 : 6}
      >
        {messages.hero.description}
      </MKTypography>
      <Stack direction="row" spacing={1} mt={3} justifyContent={centered ? "center" : "flex-start"}>
        <MKButton color="white" component="a" href="/pages/landing-pages/contact-us">
          {messages.hero.primaryAction}
        </MKButton>
        {!centered && (
          <MKButton variant="outlined" color="white" component="a" href="/construccion">
            {messages.hero.secondaryAction}
          </MKButton>
        )}
      </Stack>
    </>
  );
}

HeaderContent.propTypes = {
  centered: PropTypes.bool.isRequired,
};

function HeaderOne() {
  const { messages } = useLanguage();

  return (
    <MKBox component="header" position="relative" height="100%">
      <MKBox component="nav" position="absolute" top="0.5rem" width="100%">
        <Container>
          <Grid container flexDirection="row" alignItems="center">
            <MKBox component="a" href="/" sx={{ display: "flex", alignItems: "center", mr: 2 }}>
              <Logo style={{ height: "40px", width: "130px" }} />
            </MKBox>
            <MKButton
              variant="outlined"
              color="white"
              sx={{ display: { xs: "block", lg: "none" }, ml: "auto" }}
            >
              <MKBox component="i" color="white" className="fas fa-bars" />
            </MKButton>
            <MKBox
              component="ul"
              display={{ xs: "none", lg: "flex" }}
              p={0}
              my={0}
              mx="auto"
              sx={{ listStyle: "none" }}
            >
              <MKBox component="li">
                <MKTypography
                  component={Link}
                  href="/"
                  variant="button"
                  color="white"
                  fontWeight="regular"
                  p={1}
                >
                  {messages.nav.home}
                </MKTypography>
              </MKBox>
              <MKBox component="li">
                <MKTypography
                  component={Link}
                  href="/construccion"
                  variant="button"
                  color="white"
                  fontWeight="regular"
                  p={1}
                >
                  {messages.nav.about}
                </MKTypography>
              </MKBox>
              <MKBox component="li">
                <MKTypography
                  component={Link}
                  href="/pages/landing-pages/contact-us"
                  variant="button"
                  color="white"
                  fontWeight="regular"
                  p={1}
                >
                  {messages.nav.contact}
                </MKTypography>
              </MKBox>
            </MKBox>
          </Grid>
        </Container>
      </MKBox>
      <MKBox
        display="flex"
        alignItems="center"
        minHeight="100%"
        sx={{
          backgroundImage: ({ palette: { gradients }, functions: { linearGradient, rgba } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.5),
              rgba(gradients.dark.state, 0.5)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Container>
          <Grid container item xs={12} md={7} lg={6} flexDirection="column" justifyContent="center">
            <HeaderContent centered={false} />
          </Grid>
        </Container>
      </MKBox>
    </MKBox>
  );
}

function HeaderTwo() {
  const { messages } = useLanguage();

  return (
    <MKBox component="header" position="relative" height="100%">
      <MKBox component="nav" position="absolute" top="0.5rem" width="100%">
        <Container>
          <Grid container flexDirection="row" alignItems="center">
            <MKBox component="a" href="/" sx={{ display: "flex", alignItems: "center", mr: 2 }}>
              <Logo style={{ height: "40px", width: "130px" }} />
            </MKBox>
            <MKButton
              variant="outlined"
              color="white"
              sx={{ display: { xs: "block", lg: "none" }, ml: "auto" }}
            >
              <MKBox component="i" color="white" className="fas fa-bars" />
            </MKButton>
            <MKBox
              component="ul"
              display={{ xs: "none", lg: "flex" }}
              p={0}
              my={0}
              mx="auto"
              sx={{ listStyle: "none" }}
            >
              <MKBox component="li">
                <MKTypography
                  component={Link}
                  href="/"
                  variant="button"
                  color="white"
                  fontWeight="regular"
                  p={1}
                >
                  {messages.nav.home}
                </MKTypography>
              </MKBox>
              <MKBox component="li">
                <MKTypography
                  component={Link}
                  href="/construccion"
                  variant="button"
                  color="white"
                  fontWeight="regular"
                  p={1}
                >
                  {messages.nav.about}
                </MKTypography>
              </MKBox>
              <MKBox component="li">
                <MKTypography
                  component={Link}
                  href="/pages/landing-pages/contact-us"
                  variant="button"
                  color="white"
                  fontWeight="regular"
                  p={1}
                >
                  {messages.nav.contact}
                </MKTypography>
              </MKBox>
            </MKBox>
          </Grid>
        </Container>
      </MKBox>
      <MKBox
        display="flex"
        alignItems="center"
        minHeight="100%"
        sx={{
          backgroundImage: ({ palette: { gradients }, functions: { linearGradient, rgba } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.5),
              rgba(gradients.dark.state, 0.5)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Container>
          <HeaderContent centered={false} />
        </Container>
      </MKBox>
    </MKBox>
  );
}

function HeaderTyped() {
  const { messages } = useLanguage();

  return (
    <MKBox component="header" position="relative" height="100%">
      <MKBox component="nav" position="absolute" top="0.5rem" width="100%">
        <Container>
          <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
            <MKBox component="a" href="/" sx={{ display: "flex", alignItems: "center" }}>
              <Logo style={{ height: "36px", width: "118px" }} />
            </MKBox>
            <MKBox sx={{ display: { xs: "none", md: "flex" }, gap: 2 }}>
              <MKTypography
                component={Link}
                href="/"
                variant="button"
                color="white"
                fontWeight="regular"
                p={1}
              >
                {messages.nav.home}
              </MKTypography>
              <MKTypography
                component={Link}
                href="/construccion"
                variant="button"
                color="white"
                fontWeight="regular"
                p={1}
              >
                {messages.nav.about}
              </MKTypography>
              <MKTypography
                component={Link}
                href="/pages/landing-pages/contact-us"
                variant="button"
                color="white"
                fontWeight="regular"
                p={1}
              >
                {messages.nav.contact}
              </MKTypography>
            </MKBox>
            <MKBox sx={{ display: "flex", gap: 1 }}>
              <IconButton color="white" href="https://twitter.com/CreativeTim">
                <Twitter />
              </IconButton>
              <IconButton color="white" href="https://www.facebook.com/CreativeTim">
                <Facebook />
              </IconButton>
              <IconButton color="white" href="https://www.instagram.com/CreativeTimOfficial">
                <Instagram />
              </IconButton>
            </MKBox>
            <IconButton color="white" sx={{ display: { md: "none" } }}>
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </Container>
      </MKBox>
      <MKBox
        display="flex"
        alignItems="center"
        textAlign="center"
        minHeight="100%"
        sx={{
          backgroundImage: ({ palette: { gradients }, functions: { linearGradient, rgba } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.5),
              rgba(gradients.dark.state, 0.5)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Container>
          <HeaderContent centered />
        </Container>
      </MKBox>
    </MKBox>
  );
}

export { HeaderOne, HeaderTwo, HeaderTyped };
